import React from 'react'
import PropTypes from 'prop-types'
import {formatMessageDate} from 'ag-common/tools/dates'
import Text from '#components/a/Text'
import {parseISO} from 'ag-common/facades'

function OwnChatMessage({messageText, timestamp}) {
  return (
    <div className="chat-message-item chat-message-item__own">
      <div>
        <div className="chat-message--header">
          <div className="chat-message--header--timestamp">{formatMessageDate(parseISO(timestamp))}</div>
        </div>
        <Text text={messageText} />
      </div>
    </div>
  )
}

OwnChatMessage.propTypes = {
  messageText: PropTypes.string.isRequired,
  timestamp: PropTypes.string.isRequired,
}

export default OwnChatMessage
